module.exports = __webpack_public_path__ + "stripe_logo.png?b841dee176d2ee1d005ae5bb8d70f960";